<template>
    <div class="container">
        <div class="container-header">
            <div class="search">
                <div class="search-form">
                    <div class="form-item">
                        <span class="form-item-lable">{{ $t('activityName') }}</span>
                        <el-input v-model="search.name" size="mini" clearable @change="searchHandle"></el-input>
                    </div>
                </div>
                <div class="search-handle">
                    <el-button type="primary" size="mini" @click="searchHandle">{{ $t('search') }}</el-button>
                    <el-button type="primary" size="mini" @click="emptyHandle">{{ $t('empty') }}</el-button>
                    <el-button type="primary" size="mini" @click="addDialog = true" v-permission="['lotto:activity-create']">{{ $t('add') }}</el-button>
                </div>
            </div>
        </div>
        <div class="container-main">
            <el-table
                :data="tableData"
                border
                style="width: 100%">
                <el-table-column type="index" align="center" width="60"></el-table-column>
                <el-table-column prop="name" :label="$t('activityName')" align="center" min-width="150" show-overflow-tooltip></el-table-column>
                <el-table-column :label="$t('startTime')" align="center" width="180">
                    <template slot-scope="scope">
                        <span>{{ scope.row.startedAt | formatDate }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('endTime')" align="center" width="180">
                    <template slot-scope="scope">
                        <span>{{ scope.row.endedAt | formatDate }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('lotteryTime')" align="center" width="180">
                    <template slot-scope="scope">
                        <span>{{ scope.row.luckyDrawAt | formatDate }}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" width="120">
                    <template slot="header">
                        {{ $t('lotteryDuration') }} (h)
                    </template>
                    <template slot-scope="scope">
                        <span>{{ scope.row.durationTime }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('whetherEnable')" align="center" width="120">
                    <template slot-scope="scope">
                        <span v-if="scope.row.enabled">{{ $t('yes') }}</span>
                        <span v-else>{{ $t('no') }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('whetherPushed')" align="center" width="120">
                    <template slot-scope="scope">
                        <span v-if="scope.row.pushed">{{ $t('yes') }}</span>
                        <span v-else>{{ $t('no') }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    class-name="handle"
                    :label="$t('handle')"
                    align="center"
                    fixed="right"
                    width="240">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="mini"
                            @click="awardsHandle(scope.row.id, scope.row.name)"
                            v-permission="['lotto:activity-awards']">{{ $t('awards') }}
                        </el-button>
                        <el-button
                            type="text"
                            size="mini"
                            @click="pushHandle(scope.row.id, scope.row.itemRoomId)"
                            v-permission="['lotto:activity-push']">{{ $t('livePush') }}
                        </el-button>
                        <el-button
                            type="text"
                            size="mini"
                            @click="detailsHandle(scope.row.id, scope.row.name)"
                            v-permission="['lotto:activity-detail']">{{ $t('details') }}
                        </el-button>
                        <el-button
                            type="text"
                            size="mini"
                            @click="editHandle(scope.row.id)"
                            v-permission="['lotto:activity-update']">{{ $t('edit') }}
                        </el-button>
                        <el-button
                            class="red"
                            type="text"
                            size="mini"
                            @click="deleteHandle(scope.row.id)"
                            v-permission="['lotto:activity-delete']">{{ $t('delete') }}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                :current-page="currentPage"
                layout="sizes, prev, pager, next, total"
                :page-sizes="[10, 15, 20, 50, 100]"
                :page-size="pageSize"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange">
            </el-pagination>
        </div>
        <!-- 添加 -->
        <Add
            :parent-dialog="addDialog"
            @parent-update="getListData"
            @parent-close="addDialog = false"/>
        <!-- 编辑 -->
        <Edit
            :parent-dialog="editDialog"
            :parent-id="itemId"
            @parent-update="getListData"
            @parent-close="editDialog = false"/>
        <!-- 详情 -->
        <Details
            :parent-dialog="detailsDialog"
            :parent-id="itemId"
            @parent-close="detailsDialog = false"/>
        <!-- 直播推送 -->
        <LivePush
            :parent-dialog="pushDialog"
            :parent-id="itemId"
            :parent-room="itemRoomId"
            @parent-update="getListData"
            @parent-close="pushDialog = false"/>
    </div>
</template>

<script>
import {
    deleteLotteryActivity,
    queryLotteryActivityList
} from "@/api/modules/api";
import {mapMutations} from "vuex";
import Add from '@/components/lottery/activity/Add'
import Edit from '@/components/lottery/activity/Edit'
import Details from '@/components/lottery/activity/Details'
import LivePush from '@/components/lottery/activity/LivePush'
export default {
    name: "LotteryPeriod",
    // 组件
    components: {
        Add,
        Edit,
        Details,
        LivePush
    },
    props: {},
    data() {
        return {
            search: {
                name: ''
            },
            stateOptions: [
                {
                    label: this.$t('condition'),
                    value: 101
                },
                {
                    label: this.$t('special'),
                    value: 102
                }
            ],
            tableData: [],
            currentPage: 1,
            total: 0,
            pageSize: 10,
            itemId: '',
            addDialog: false,
            editDialog: false,
            detailsDialog: false,
            itemRoomId: '',
            pushDialog: false,
        };
    },
    // 计算属性
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        ...mapMutations('other', ['saveLotteryPeriodInfo']),
        // 获取数据列表
        getListData() {
            const params = {
                name: this.search.name,
                page: this.currentPage,
                size: this.pageSize
            }
            queryLotteryActivityList(params).then(res => {
                if (Number(res.code) === 20000) {
                    this.tableData = res.data.list
                    this.total = res.data.total
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch(err => {
                this.$message.error(err)
            })
        },
        
        // 搜索
        searchHandle () {
            // 当前页码初始化
            this.currentPage = 1
            // 获取列表数据
            this.getListData()
        },
        // 清空
        emptyHandle () {
            this.search = {
                name: ''
            }
            this.currentPage = 1
            // 获取列表数据
            this.getListData()
        },
        // 切换页码
        handleCurrentChange (page) {
            // 设置页码
            this.currentPage = page
            // 获取列表数据
            this.getListData()
        },
        // 切换显示条数
        handleSizeChange (size) {
            // 设置大小
            this.pageSize = size
            // 初始化页码
            this.currentPage = 1
            // 获取列表数据
            this.getListData()
        },
        // 详情
        detailsHandle (id, name) {
            this.saveLotteryPeriodInfo({
                id,
                name
            })
            this.itemId = id
            this.detailsDialog = true
        },
        // 奖项
        awardsHandle (id, name) {
            this.saveLotteryPeriodInfo({
                id,
                name
            })
            this.$router.push({
                name: 'LotteryAwards',
                params: {
                    id
                }
            })
        },
        // 编辑
        editHandle (id) {
            this.itemId = id
            this.editDialog = true
        },
        // 删除
        deleteHandle (id) {
            this.$confirm(this.$t('deleteItemHint'), this.$t('hint'), {
                confirmButtonText: this.$t('confirm'),
                cancelButtonText: this.$t('cancel'),
                type: 'warning'
            }).then(() => {
                deleteLotteryActivity(id).then(res => {
                    if (Number(res.code) === 20000) {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'success'
                        })
                        this.getListData()
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'error'
                        })
                    }
                }).catch(err => {
                    this.$message.error(err)
                })
            }).catch(() => {})
        },
        // 直播推送
        pushHandle (id, room = '') {
            this.itemId = id
            this.itemRoomId = room
            this.pushDialog = true
        },
    },
    // 创建完成
    created() {
    },
    // 挂载完成
    mounted() {
        // 获取列表数据
        this.getListData()
    },
    // 销毁之前
    beforeDestroy() {
    }
};
</script>

<style lang="scss" scoped>
@import '../../assets/css/base-column.scss';
.picture{
    width: 100%;
    height: 50px;
    text-align: center;
    img{
        width: 50px;
        height: 50px;
    }
}
</style>
